// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidabar_sidebar__NcZ5g","content":"Sidabar_content__PFcNN"};